<script>
import useSharedSelectData from "@/use/SharedSelectData";
import {ref, watch} from "vue";

export default {
    name: "RecruitmentRequestFilter",
    props: {
        value: Object,
        planning: Boolean,
    },
    setup(props, {emit}) {
        const {workerPhases, validationWorkFlowStatus} = useSharedSelectData();
        const panelModel = ref(0);

        const filter = ref({});

        watch(() => filter.value, () => {
            emit('input', filter.value);
        }, {deep: true});


        return {
            filter,
            workerPhases,
            validationWorkFlowStatus,
            panelModel
        }
    },
};
</script>

<template>
    <div>
        <v-expansion-panels v-model="panelModel" dense focusable>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <strong>{{ $t('module.recruitment_request') }}</strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mr-n5 ml-n5">
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <str-worker-autocomplete
                                        v-model="filter.workerId"
                                        :label="$t('recruitment_request.applicant')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-occupation-autocomplete
                                        v-model="filter.positionId"
                                        :label="$t('recruitment_request.occupation')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-data-select-autocomplete
                                        v-model="filter.reasonId"
                                        :label="$t('recruitment_request.reason')"
                                        type="RECRUITMENT_REASON"
                                />
                            </v-col>
                            <v-col cols="12">
                                <str-recruitment-state-autocomplete
                                        v-model="filter.state"
                                />
                            </v-col>
                            <v-col cols="12" v-if="planning">
                                <str-worker-autocomplete
                                    v-model="filter.principalExpertId"
                                    :label="$t('recruitment_request.principal_expert')"
                                />
                            </v-col>
                            <v-col cols="12">
                                <w-enum-select
                                    v-model="filter.validationStatus"
                                    :items="validationWorkFlowStatus"
                                    :label="$t('common.validation')"
                                    multiple
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <input type="hidden"/>
    </div>
</template>